import { render, staticRenderFns } from "./CreateIntershipNewsPopup.vue?vue&type=template&id=c77ad04c"
import script from "./CreateIntershipNewsPopup.vue?vue&type=script&lang=js"
export * from "./CreateIntershipNewsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports